import './TrimMeetingModal.scss'
import { ReactComponent as ZocksLogo } from '../../../../../assets/images/ZocksIcon-primary.svg'
import React from 'react'

export const TrimMeetingLoading = () => {
  return (
    <div className='trim-meeting-container d-flex flex-column align-items-center justify-content-center'>
      <div>
        <ZocksLogo width='2rem' height='2rem' />
      </div>
      <div className='zocks-loading-dot-dot-dot' />
      <div className='paragraph-large'>Trimming your meeting...</div>
      <div className='zocks-text-gray-900'>After trimming, Zocks will process the meeting again.</div>
    </div>
  )
}
